import {
  CREATEHOLIDAYDATE,
  GETHOLIDAYDATE,
  DELETEHOLIDAYDATE,
  UPDATEHOLIDAYDATE,
} from "../actions/types";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case GETHOLIDAYDATE:
      return {
        ...state,
        holidaydateList: action.payload.data,
      };
    case UPDATEHOLIDAYDATE:
      return {
        ...state,
        holidaydateUpdateStatus: action.payload.success,
      };

    case DELETEHOLIDAYDATE:
      return {
        ...state,
        holidaydateDeleteStatus: action.payload.success,
      };

    default:
      return state;
  }
}
